import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChoices = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "choices",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17381",
		"data-name": "Group 17381",
		transform: "translate(3.993 4.115)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12846",
				"data-name": "Path 12846",
				d: "M9.4,15.1a3.75,3.75,0,1,1-5.3,0,3.75,3.75,0,0,1,5.3,0",
				transform: "translate(-3 -7.105)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12847",
				"data-name": "Path 12847",
				d: "M18.5,10.75l3.125-3.125L18.5,4.5",
				transform: "translate(0.389 -4.536)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12852",
				"data-name": "Path 12852",
				d: "M18.5,10.75l3.125-3.125L18.5,4.5",
				transform: "translate(0.389 11.056)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12850",
				"data-name": "Path 12850",
				d: "M21.154,14.54s-1.59.035-3.316,0-2.467.075-3.271-.852-.625-1.327-.7-3.639S11.467,6.979,10.25,7A11.334,11.334,0,0,1,9,7",
				transform: "translate(-1.25 4.125)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12851",
				"data-name": "Path 12851",
				d: "M21.154,7.015s-1.59-.035-3.316,0-2.467-.075-3.271.852-.625,1.327-.7,3.638-2.4,3.071-3.615,3.05a11.335,11.335,0,0,0-1.25,0",
				transform: "translate(-1.25 -3.911)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12849",
		"data-name": "Path 12849",
		d: "M0,0H30V30H0Z",
		fill: "none"
	})]
});
export default SvgChoices;
